import { PasswordFormData, PasswordErrorMsg } from '../interface/common';

export const initFormData: PasswordFormData = {
    email: '',
    password: '',
    confirm_password: '',
};

export const initErrorMsg: PasswordErrorMsg = {
    password: '',
    confirm_password: '',
    server_error: '',
};

export const passwordValidationRules = [
    { regex: /.{8,}/, message: 'Must be at least 8 characters long.' },
    {
        regex: /[A-Z]/,
        message: 'Must contain at least one uppercase letter.',
    },
    {
        regex: /[a-z]/,
        message: 'Must contain at least one lowercase letter.',
    },
    { regex: /[0-9]/, message: 'Must contain at least one number.' },
    {
        regex: /[!@#$%^&*(),.?":{}|<>]/,
        message: 'Must contain at least one special character.',
    },
];

export const validatePassword = (password: string): { isValid: boolean; message: string } => {
    for (let rule of passwordValidationRules) {
        if (!rule.regex.test(password)) {
            return {
                isValid: false,
                message: rule.message,
            };
        }
    }

    return {
        isValid: true,
        message: '',
    };
};

export const validatePasswordMatch = (password: string, confirmPassword: string): boolean => password === confirmPassword;

export const handlePasswordValidation = (formData: PasswordFormData, setErrorMsg: (errors: PasswordErrorMsg) => void, setIsStrongPassword?: (isStrong: boolean) => void): boolean => {
    const { isValid, message } = validatePassword(formData.password);

    if (!isValid) {
        setErrorMsg({
            password: message,
            confirm_password: '',
            server_error: '',
        });
        setIsStrongPassword?.(false);

        return false;
    }

    if (!validatePasswordMatch(formData.password, formData.confirm_password)) {
        setErrorMsg({
            password: '',
            confirm_password: "Confirm password doesn't match",
            server_error: '',
        });

        return false;
    }

    setErrorMsg({
        password: '',
        confirm_password: '',
        server_error: '',
    });
    setIsStrongPassword?.(true);

    return true;
};
